import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0adc53cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-center py-8 bg-white p-6"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 animate-spin",
  viewBox: "0 0 100 100"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "none",
    "stroke-width": "10",
    class: "stroke-current opacity-40",
    cx: "50",
    cy: "50",
    r: "40"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "none",
    "stroke-width": "10",
    class: "stroke-current",
    "stroke-dasharray": "250",
    "stroke-dashoffset": "210",
    cx: "50",
    cy: "50",
    r: "40"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "form-card-tabs-container px-48"
}
const _hoisted_5 = { class: "columns-1 mt-6" }
const _hoisted_6 = { class: "columns-2 mt-6" }
const _hoisted_7 = {
  class: "columns-2 mt-6 flex gap-4 items-end",
  ref: "scrollUp"
}
const _hoisted_8 = { class: "text-[#344054] font-medium text-sm" }
const _hoisted_9 = {
  key: 0,
  class: "absolute z-10 top-[100%] font-normal text-sm pt-1"
}
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = { class: "columns-2 mt-6" }
const _hoisted_12 = { class: "columns-2 mt-6" }
const _hoisted_13 = { class: "mt-10" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-dark-grey font-semibold text-xl my-6" }, "New License", -1))
const _hoisted_15 = { class: "grid grid-cols-4 gap-x-4 gap-y-8" }
const _hoisted_16 = { class: "text-dark-grey font-medium text-2xl my-6" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_18 = {
  key: 0,
  class: "flex items-center justify-center py-8 bg-white p-6"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 animate-spin",
  viewBox: "0 0 100 100"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "none",
    "stroke-width": "10",
    class: "stroke-current opacity-40",
    cx: "50",
    cy: "50",
    r: "40"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "none",
    "stroke-width": "10",
    class: "stroke-current",
    "stroke-dasharray": "250",
    "stroke-dashoffset": "210",
    cx: "50",
    cy: "50",
    r: "40"
  })
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "absolute right-[-2rem] top-8" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "flex justify-between items-center mt-4" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.0001 4.16663V15.8333M4.16675 9.99996H15.8334",
    stroke: "#475467",
    "stroke-width": "1.66667",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_25 = { class: "font-semibold text-sm color-[#475467]" }
const _hoisted_26 = {
  key: 0,
  class: "rounded-md p-4 mt-5 bg-red-50"
}
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = { class: "flex-shrink-0" }
const _hoisted_29 = { class: "ml-3" }
const _hoisted_30 = { class: "'text-sm font-medium text-red-800" }
const _hoisted_31 = { class: "ml-auto pl-3" }
const _hoisted_32 = { class: "-mx-1.5 -my-1.5" }
const _hoisted_33 = { class: "sr-only" }
const _hoisted_34 = { class: "flex items-end justify-end mt-3" }
const _hoisted_35 = ["disabled", "onClick"]
const _hoisted_36 = { class: "font-semibold text-sm" }
const _hoisted_37 = {
  key: 0,
  class: "flex items-center justify-center gap-x-1"
}
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  key: 1,
  class: "rounded-md bg-green-50 p-4 mt-5"
}
const _hoisted_40 = { class: "flex" }
const _hoisted_41 = { class: "flex-shrink-0" }
const _hoisted_42 = { class: "ml-3" }
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = { class: "ml-auto pl-3" }
const _hoisted_45 = { class: "-mx-1.5 -my-1.5" }
const _hoisted_46 = { class: "sr-only" }

import { computed, ref, watch } from 'vue';
import { useAdminStore } from '@/stores/adminStore';
import { useSchoolStore } from '@/stores/schoolStore';
import { useLearnerStore } from '@/stores/learnerStore';
import { useFilterStore } from '@/stores/filterStore';
import i18n from '@/plugins/i18n';
import { countryOptions } from '@/helper/countries';
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/vue/20/solid";
import { TrashIcon, XMarkIcon } from "@heroicons/vue/24/outline";
import omitBy from 'lodash/omitBy';
import isEmpty from 'lodash/isEmpty';
import { CheckCircleIcon, XCircleIcon } from "@heroicons/vue/20/solid";
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
} from "@headlessui/vue";
import { FormKitNode } from '@formkit/core';
import { Admin } from '@/interfaces/admin.interface';
import { useSchoolGroupStore } from '@/stores/schoolGroupsStore';
import { useProductStore } from '@/stores/productStore';

import { NewLicenseFormData } from '@/interfaces/license.interface';

interface SearchOption {
  id: string;
  name: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AddSchoolComponent',
  setup(__props) {

const schoolStore = useSchoolStore();
const learnerStore = useLearnerStore();
const adminStore = useAdminStore();
const filterStore = useFilterStore();
const schoolGroup = useSchoolGroupStore();
const productStore = useProductStore();

const selectedOption = ref<SearchOption | null>(null);
const showRequired = ref(false);
const buttonIsDisabled = ref(false);
const searchQuery = ref("");
const placeholder = ref(i18n.global.t("internal_tools.select").toString());
const updateSuccess = ref(false);
const responseMessage = ref("");
const newAdmins = ref<Admin[]>([]);
const showErrorMessage = ref(false);

const newAdmin = ref({
  firstName: "",
  lastName: "",
  email: "",
  designation: "School Champion",
  status: "inactive",
  roles: [],
  phoneNumber: null,
}) as any;

const schoolObject = ref({
  name: "",
  domain: "",
  emisNumber: "",
  schoolGroup: filterStore.selectedFilters.schoolGroup as string,
  academicYearStart: "",
  academicYearEnd: "",
  preferredLang: "",
  location: {
    city: "",
    country: "",
    street: "",
  },
  schoolLicenseData: {
    type: 'annual',
    startDate: '',
    endDate: '',
    products: productStore.products.map(product => ({
      product: product._id,
      maxSeats: 0,
      seatsUsed: 0,
    }))
  } as NewLicenseFormData
});

const schoolLicenses = ref<any>({});
const targetBlock = ref<HTMLElement | null>(null);

// Computed filtered options based on `searchQuery`
const filteredOptions = computed(() =>
  searchQuery.value === ""
    ? countryOptions
    : countryOptions.filter((o) =>
      o.name.toLowerCase().includes(searchQuery.value.toLowerCase())
    )
);

// Computed property for FormKit select options
const localeOptions = computed(() =>
  schoolStore.getLocales.map(locale => ({
    label: locale.name,
    value: locale.code
  }))
);

const removeChampion = (index: number) => {
  newAdmins.value.splice(index, 1);
};

// Change coutry casing
const formatCountryName = (country: string) => {

  //check if the country is in the countryOptions
  const countryExist = countryOptions.find((o) => o.id === country);

  //if the country is not in the countryOptions, return the selectedOption value
  if (!countryExist) {
    return selectedOption.value?.name;
  }

  return country
    ? country
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
    : '';
}

const closeSuccess = () => {
  updateSuccess.value = false;
  responseMessage.value = "";
};

const handleNext = async () => {
  // Check if required fields are filled
  if (schoolObject.value.location.country.trim().length === 0) {
    showRequired.value = true;
    return;
  }

  // Extract month and day from academicYearStart and academicYearEnd
  const formatDate = (dateString: any) => {
    const dateParts = dateString.split('-');
    if (dateParts.length === 3) {
      const month = dateParts[1];
      const day = dateParts[2];
      return `${month}-${day}`; // Return MM-DD
    }
    return dateString;
  };

  // Format the academicYearStart and academicYearEnd
  schoolObject.value.academicYearStart = formatDate(schoolObject.value.academicYearStart);
  schoolObject.value.academicYearEnd = formatDate(schoolObject.value.academicYearEnd);

  // Prepare the payload by removing empty fields 
  const preparedPayload = omitBy(schoolObject.value, (value) => isEmpty(value) && typeof value === 'string');

  // Create a new school with the prepared payload
  const result = await schoolStore.createSchool(preparedPayload);

  // Add new admins to the school and handle the success message if the school was created
  if (result) {
    let championsCount = 0;

    if (newAdmins.value.length > 0) {

      for (const admin of newAdmins.value) {
        // Check if all necessary fields are filled
        if (admin.firstName && admin.lastName && admin.email) {

          // Add school key to admin
          admin.school = result._id;

          // Create a new admin
          const res = await adminStore.createNewAdmin(admin);

          if (res) {
            // Increment counter for successful admin creation
            championsCount++;
          }
        } else {
          console.log("Admin data is incomplete");
        }
      }
    }

    responseMessage.value = i18n.global
      .t("internal_tools.add_school.school_message")
      .toString();

    if (championsCount > 0) {
      responseMessage.value += "<br/> " + "- " + i18n.global.t(
        "internal_tools.add_school.champion_message",
        { schoolAdminMessage: championsCount }
      ).toString();
    }

    updateSuccess.value = true;

    // Update the filter store with new school.
    filterStore.addSchoolToSchoolGroup(result, filterStore.selectedFilters.schoolGroup as string, true);

  }
};

const email_exists = async (node: FormKitNode): Promise<boolean> => {
  try {
    const emailExists = await schoolStore?.validateEmail(node.value as string);
    buttonIsDisabled.value = emailExists; // Disable button if email exists
    return !emailExists; // Validation passes if email does not exist
  } catch (error) {
    buttonIsDisabled.value = true; // Disable on error
    return true;
  }
};

const addChampion = () => {
  // Spread newAdmin to create a new instance and generate a unique _id
  newAdmins.value.push({
    ...newAdmin.value,
    _id: Math.random().toString(36).substring(2) + Date.now().toString(36),
  });
};

// Watch `selectedOption` to update `searchQuery` and bind to `schoolObject` country ID
watch(selectedOption, (newOption) => {
  searchQuery.value = newOption ? newOption.name : "";
  schoolObject.value.location.country = newOption?.id || "";
});

const clearData = () => {
  // Clear the newAdmins array
  newAdmins.value = [];

  // Clear the schoolObject
  schoolObject.value = {
    name: "",
    domain: "",
    emisNumber: "",
    schoolGroup: filterStore.selectedFilters.schoolGroup as string,
    academicYearStart: "",
    academicYearEnd: "",
    preferredLang: "",
    location: {
      city: "",
      country: "",
      street: "",
    },
    schoolLicenseData: {
      type: 'annual',
      startDate: '',
      endDate: '',
      products: productStore.products.map(product => ({
        product: product._id,
        maxSeats: 0,
        seatsUsed: 0,
      }))
    } as NewLicenseFormData
  };

  //clear success message
  updateSuccess.value = false;

  //trying to clear the country value
  selectedOption.value = { id: "", name: "" };

  // Clear school Licenses
  schoolLicenses.value = {};
};

watch(() => filterStore.selectedFilters.schoolGroup, clearData);


return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!

  return (
    _unref(schoolStore).loading === true || _unref(schoolGroup).loading === true || _unref(learnerStore).loader.learner === true
  )
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createVNode(_component_FormKit, {
          type: "form",
          id: "new-school-creation",
          actions: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_FormKit, {
                type: "text",
                label: _ctx.$t('internal_tools.form.school_name'),
                "outer-class": "primary-select",
                "inner-class": "bg-white",
                placeholder: _ctx.$t('internal_tools.form.school_name'),
                modelValue: schoolObject.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((schoolObject.value.name) = $event)),
                validation: "required",
                "validation-messages": {
            required: _ctx.$t('internal_tools.add_school.school_name')
          }
              }, null, 8, ["label", "placeholder", "modelValue", "validation-messages"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_FormKit, {
                type: "text",
                label: _ctx.$t('internal_tools.form.school_location'),
                "outer-class": "primary-select",
                "inner-class": "bg-white",
                placeholder: _ctx.$t('internal_tools.form.school_location'),
                modelValue: schoolObject.value.location.street,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((schoolObject.value.location.street) = $event)),
                validation: "required",
                "validation-messages": {
            required: _ctx.$t('internal_tools.add_school.school_location')
          }
              }, null, 8, ["label", "placeholder", "modelValue", "validation-messages"]),
              _createVNode(_component_FormKit, {
                type: "text",
                label: _ctx.$t('internal_tools.form.domain_name'),
                "outer-class": "primary-select ",
                placeholder: _ctx.$t('internal_tools.form.domain_name'),
                modelValue: schoolObject.value.domain,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((schoolObject.value.domain) = $event)),
                validation: [
            ['required'],
            [
              'matches',
              /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
            ],
          ],
                "validation-messages": {
            required:
              _ctx.$t('internal_tools.add_school.domain_name'),
            matches:
              _ctx.$t('internal_tools.add_school.domain_example'),
          }
              }, null, 8, ["label", "placeholder", "modelValue", "validation", "validation-messages"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_FormKit, {
                class: "w-1/2",
                type: "text",
                label: _ctx.$t('internal_tools.form.city'),
                "outer-class": "primary-select w-1/2",
                placeholder: _ctx.$t('internal_tools.form.city_name'),
                modelValue: schoolObject.value.location.city,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((schoolObject.value.location.city) = $event)),
                validation: "required",
                "validation-messages": {
            required: _ctx.$t('internal_tools.add_school.city_name')
          }
              }, null, 8, ["label", "placeholder", "modelValue", "validation-messages"]),
              _createVNode(_unref(Combobox), {
                class: "w-1/2 relative",
                as: "div",
                modelValue: selectedOption.value,
                "onUpdate:modelValue": [
                  _cache[6] || (_cache[6] = ($event: any) => ((selectedOption).value = $event)),
                  _cache[7] || (_cache[7] = ($event: any) => (searchQuery.value = ''))
                ],
                label: _ctx.$t('internal_tools.form.city')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('internal_tools.form.country_title')), 1),
                  (showRequired.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t('internal_tools.add_school.couunty_name')), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_unref(ComboboxInput), {
                      class: "w-full rounded-md border-0 bg-white py-[18px] pl-3 pr-10 text-[#6a737f] shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 font-normal text-base",
                      placeholder: placeholder.value,
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (searchQuery.value = $event.target.value)),
                      onBlur: _cache[5] || (_cache[5] = ($event: any) => (searchQuery.value = '')),
                      "display-value": () => formatCountryName(schoolObject.value.location.country) || '',
                      validation: "required"
                    }, null, 8, ["placeholder", "display-value"]),
                    _createVNode(_unref(ComboboxButton), { class: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ChevronUpDownIcon), {
                          class: "h-5 w-5 text-gray-400",
                          "aria-hidden": "true"
                        })
                      ]),
                      _: 1
                    }),
                    (filteredOptions.value.length > 0)
                      ? (_openBlock(), _createBlock(_unref(ComboboxOptions), {
                          key: 0,
                          class: "dropdown-options absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (option) => {
                              return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                                key: option.id,
                                value: option,
                                as: "template"
                              }, {
                                default: _withCtx(({ active, selected }) => [
                                  _createElementVNode("li", {
                                    class: _normalizeClass([
                  'relative cursor-default select-none py-2 pl-8 pr-4',
                  active ? 'bg-indigo-600 text-white' : 'text-gray-900',
                ])
                                  }, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(['block truncate', selected && 'font-semibold'])
                                    }, _toDisplayString(option.name), 3),
                                    selected
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: _normalizeClass([
                    'absolute inset-y-0 left-0 flex items-center pl-1.5',
                    active ? 'text-white' : 'text-[#155EEF]',
                  ])
                                        }, [
                                          _createVNode(_unref(CheckIcon), {
                                            class: "h-5 w-5",
                                            "aria-hidden": "true"
                                          })
                                        ], 2))
                                      : _createCommentVNode("", true)
                                  ], 2)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "label"])
            ], 512),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_FormKit, {
                type: "select",
                name: "locale",
                options: localeOptions.value,
                label: _ctx.$t('internal_tools.form.language_title'),
                "outer-class": "primary-select",
                placeholder: _ctx.$t('internal_tools.form.language'),
                style: { color: '#667085', height: '3.5rem' },
                modelValue: schoolObject.value.preferredLang,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((schoolObject.value.preferredLang) = $event)),
                validation: "required",
                "validation-messages": {
            required: _ctx.$t('internal_tools.add_school.language')
          }
              }, null, 8, ["options", "label", "placeholder", "modelValue", "validation-messages"]),
              _createVNode(_component_FormKit, {
                type: "text",
                label: _ctx.$t('internal_tools.form.emis_number'),
                "outer-class": "primary-select",
                placeholder: _ctx.$t('internal_tools.form.emis_number'),
                modelValue: schoolObject.value.emisNumber,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((schoolObject.value.emisNumber) = $event))
              }, null, 8, ["label", "placeholder", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_FormKit, {
                type: "date",
                label: _ctx.$t('internal_tools.form.start_month'),
                "outer-class": "primary-select",
                placeholder: _ctx.$t('internal_tools.form.month'),
                modelValue: schoolObject.value.academicYearStart,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((schoolObject.value.academicYearStart) = $event)),
                validation: "required",
                "validation-messages": {
            required: _ctx.$t('internal_tools.add_school.start_date')
          }
              }, null, 8, ["label", "placeholder", "modelValue", "validation-messages"]),
              _createVNode(_component_FormKit, {
                type: "date",
                label: _ctx.$t('internal_tools.form.end_month'),
                "outer-class": "primary-select",
                placeholder: _ctx.$t('internal_tools.form.month'),
                modelValue: schoolObject.value.academicYearEnd,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((schoolObject.value.academicYearEnd) = $event)),
                validation: "required",
                "validation-messages": {
            required: _ctx.$t('internal_tools.add_school.end_date')
          }
              }, null, 8, ["label", "placeholder", "modelValue", "validation-messages"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_FormKit, {
                  type: "date",
                  name: "startDate",
                  modelValue: schoolObject.value.schoolLicenseData.startDate,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((schoolObject.value.schoolLicenseData.startDate) = $event)),
                  label: "New License Start Date",
                  placeholder: "Select Start Date",
                  classes: { outer: 'col-span-2' },
                  validation: `required`,
                  validationMessages: {
              required: 'Start date is required',
              date_after: 'Start date must be after today'
            }
                }, null, 8, ["modelValue"]),
                _createVNode(_component_FormKit, {
                  type: "date",
                  name: "endDate",
                  label: "New License End Date",
                  placeholder: "Select End Date",
                  classes: { outer: 'col-span-2' },
                  validation: `required|date_after_field:startDate`,
                  validationMessages: {
              required: 'End date is required',
              date_after: 'End date must be after start date',
            },
                  modelValue: schoolObject.value.schoolLicenseData.endDate,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((schoolObject.value.schoolLicenseData.endDate) = $event))
                }, null, 8, ["modelValue"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productStore).products, (product) => {
                  return (_openBlock(), _createBlock(_component_FormKit, {
                    key: product._id,
                    type: "number",
                    name: `product_${product._id}`,
                    label: `${product.name} Seats`,
                    placeholder: "Enter number of seats",
                    validation: "required|min:0",
                    validationMessages: {
              required: 'Number of seats is required',
              min: 'At least 0 seat is required',
            },
                    classes: { outer: 'col-span-2' },
                    modelValue: schoolObject.value.schoolLicenseData.products.find(p => p.product === product._id).maxSeats,
                    "onUpdate:modelValue": ($event: any) => ((schoolObject.value.schoolLicenseData.products.find(p => p.product === product._id).maxSeats) = $event)
                  }, null, 8, ["name", "label", "modelValue", "onUpdate:modelValue"]))
                }), 128))
              ])
            ]),
            _createElementVNode("h1", _hoisted_16, _toDisplayString(_ctx.$t("internal_tools.form.add_champion")), 1),
            _hoisted_17,
            (_unref(schoolStore).schoolStructureLoader === true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(newAdmins.value, (admin, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: admin._id,
                    class: "columns-5 mt-4 mb-2 relative"
                  }, [
                    _createVNode(_component_FormKit, {
                      type: "text",
                      label: _ctx.$t('internal_tools.form.champion_name'),
                      "outer-class": "primary-select",
                      placeholder: _ctx.$t('internal_tools.form.champion_name'),
                      modelValue: admin.firstName,
                      "onUpdate:modelValue": ($event: any) => ((admin.firstName) = $event),
                      style: { position: 'relative' },
                      validation: "required",
                      "messages-class": 'absolute'
                    }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      label: _ctx.$t('internal_tools.form.champion_surname'),
                      "outer-class": "primary-select",
                      placeholder: _ctx.$t('internal_tools.form.champion_surname'),
                      modelValue: admin.lastName,
                      "onUpdate:modelValue": ($event: any) => ((admin.lastName) = $event),
                      style: { position: 'relative' },
                      validation: "required",
                      "messages-class": 'absolute'
                    }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_FormKit, {
                      type: "email",
                      label: _ctx.$t('internal_tools.form.champion_email'),
                      "outer-class": "primary-select",
                      placeholder: _ctx.$t('internal_tools.form.champion_email'),
                      modelValue: admin.email,
                      "onUpdate:modelValue": ($event: any) => ((admin.email) = $event),
                      validation: "required|email|(500)email_exists",
                      style: { position: 'relative' },
                      "validation-rules": { email_exists: email_exists },
                      "validation-messages": {
            email_exists: _ctx.$t(
              'add_grades_class_component.step_1.email_exists'
            ),
          },
                      "messages-class": 'absolute'
                    }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue", "validation-rules", "validation-messages"]),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      label: _ctx.$t('internal_tools.form.champion_title'),
                      "outer-class": "primary-select",
                      placeholder: _ctx.$t('internal_tools.form.champion_title'),
                      readonly: "",
                      style: { cursor: 'not-allowed', backgroundColor: '#D2D9E1' },
                      modelValue: admin.designation,
                      "onUpdate:modelValue": ($event: any) => ((admin.designation) = $event)
                    }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_FormKit, {
                      type: "number",
                      label: _ctx.$t('internal_tools.form.champion_phone'),
                      "outer-class": "primary-select",
                      placeholder: _ctx.$t('internal_tools.form.champion_phone'),
                      modelValue: admin.phoneNumber,
                      "onUpdate:modelValue": ($event: any) => ((admin.phoneNumber) = $event)
                    }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("button", {
                        onClick: _withModifiers(($event: any) => (removeChampion(index)), ["prevent"]),
                        class: "mt-2 text-red-500"
                      }, [
                        _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
                      ], 8, _hoisted_22)
                    ])
                  ]))
                }), 128))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("button", {
            class: "flex gap-[6px] items-center pr-4 py-2 rounded-[1.25rem] justify-center text-[#475467]",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (addChampion()))
          }, [
            _hoisted_24,
            _createElementVNode("h1", _hoisted_25, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.btn_add")), 1)
          ])
        ]),
        (showErrorMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_unref(XCircleIcon), {
                    class: "h-5 w-5 text-red-400",
                    "aria-hidden": "true"
                  })
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t("internal_tools.multiple_schools_component.create_license")), 1)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "inline-flex rounded-md bg-red-50 p-1.5 text-red-500",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (showErrorMessage.value = false))
                    }, [
                      _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("internal_tools.success.btnClose")), 1),
                      _createVNode(_unref(XMarkIcon), {
                        class: "h-5 w-5",
                        "aria-hidden": "true"
                      })
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("button", {
            class: _normalizeClass('px-[14px] py-[10px] text-white bg-[#155EEF] border border-[#155EEF] rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500' +
        (_unref(adminStore).loader.creatingAdmin ||
          _unref(schoolStore).updateLoader ||
          buttonIsDisabled.value ||
          schoolObject.value.name.trim() === '' ||
          schoolObject.value.location.street.trim().length === 0 ||
          schoolObject.value.location.country.trim().length === 0 ||
          schoolObject.value.location.city.trim().length === 0 ||
          schoolObject.value.domain.trim().length === 0 ||
          schoolObject.value.preferredLang.trim().length === 0 ||
          schoolObject.value.academicYearStart.trim().length === 0 ||
          schoolObject.value.academicYearEnd.trim().length === 0 ||
          schoolObject.value.schoolLicenseData.startDate.trim().length === 0 ||
          schoolObject.value.schoolLicenseData.endDate.trim().length === 0
          ? 'opacity-50 cursor-not-allowed'
          : 'cursor-pointer')
        ),
            disabled: _unref(adminStore).loader.creatingAdmin ||
          _unref(schoolStore).updateLoader ||
          buttonIsDisabled.value ||
          schoolObject.value.name.trim().length === 0 ||
          schoolObject.value.location.street.trim().length === 0 ||
          schoolObject.value.location.country.trim().length === 0 ||
          schoolObject.value.location.city.trim().length === 0 ||
          schoolObject.value.domain.trim().length === 0 ||
          schoolObject.value.preferredLang.trim().length === 0 ||
          schoolObject.value.academicYearStart.trim().length === 0 ||
          schoolObject.value.academicYearEnd.trim().length === 0 ||
          schoolObject.value.schoolLicenseData.startDate.trim().length === 0 ||
          schoolObject.value.schoolLicenseData.endDate.trim().length === 0,
            onClick: _withModifiers(handleNext, ["prevent"])
          }, [
            _createElementVNode("h1", _hoisted_36, [
              (
            _unref(schoolStore).schoolCreationLoader
          )
                ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                    _createVNode(_component_spinner_loader, { color: 'text-white' }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("internal_tools.add_school.create_school")), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.$t("internal_tools.form.btnSave")), 1))
            ])
          ], 10, _hoisted_35)
        ]),
        (updateSuccess.value || responseMessage.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_unref(CheckCircleIcon), {
                    class: "h-5 w-5 text-green-400",
                    "aria-hidden": "true"
                  })
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("p", {
                    class: "text-sm font-medium text-green-800",
                    innerHTML: responseMessage.value
                  }, null, 8, _hoisted_43)
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "inline-flex rounded-md bg-green-50 p-1.5 text-green-500 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-green-50",
                      onClick: closeSuccess
                    }, [
                      _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t("internal_tools.success.btnClose")), 1),
                      _createVNode(_unref(XMarkIcon), {
                        class: "h-5 w-5",
                        "aria-hidden": "true"
                      })
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
}
}

})